/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./putTarget.defs.js";
export { main as default } from "./putTarget.defs.js";
